/**
 * ToolProgressStrip — Phase 9.3 (2026-05-24) tool_progress activity strip.
 *
 * Renders one entry per emitted backend `tool_progress` WS frame, cleared
 * on end_of_turn (CONC-9.3-3 via writeIdleToOriginTab). Bounded to 10
 * entries (CONC-9.3-1 schema-extensible).
 *
 * Extracted from VoicePanel.tsx as part of DESHITTIFICATION Phase 3
 * (2026-05-26 — vibe-designer-voicepanel-decomp-v1.0.0). Smart-subcomponent
 * pattern: reads `currentToolProgress` directly from `useVoiceStore`, no
 * props. Sibling rendering inside VoicePanel parent.
 */
import { useVoiceStore } from '@/stores/voiceStore';
import { humanizeTool } from './humanizeTool';

export function ToolProgressStrip() {
  const currentToolProgress = useVoiceStore((s) => s.currentToolProgress);

  if (!currentToolProgress || currentToolProgress.length === 0) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap items-center gap-2 px-3 py-1 border-b border-vibe-border bg-vibe-bg-secondary text-xs text-vibe-text-secondary"
      data-testid="voice-tool-progress-strip"
    >
      {currentToolProgress.map((entry, idx) => (
        <span
          key={`${entry.tool}-${entry.step}-${entry.status}-${idx}`}
          data-testid={`tool-progress-${entry.step}-${entry.status}`}
          data-tool={entry.tool}
          data-status={entry.status}
          className={
            entry.status === 'failed'
              ? 'text-vibe-error'
              : entry.status === 'completed'
              ? 'text-vibe-text'
              : ''
          }
        >
          {humanizeTool(entry.tool, entry.status)}
          {entry.error && <span className="ml-1 opacity-75">— {entry.error}</span>}
        </span>
      ))}
    </div>
  );
}
